// const isDevelopment = import.meta.env.MODE === "development";
const isDevelopment = import.meta.env.VITE_MODE === "development";
console.log("Environment mode is:", import.meta.env.VITE_MODE);

// Log environment variables for debugging
console.log("DEV API URL:", import.meta.env.VITE_API_URL_DEV);
console.log("PROD API URL:", import.meta.env.VITE_API_URL_PROD);

// API URLs with fallback
export const API_URL = isDevelopment
  ? import.meta.env.VITE_API_URL_DEV || "http://localhost:3000"
  : import.meta.env.VITE_API_URL_PROD || "https://backend.efficia.ai";

console.log("Using API_URL:", API_URL);

// Frontend URLs with fallback
export const FRONTEND_URL = isDevelopment
  ? import.meta.env.VITE_FRONTEND_URL_DEV || "http://localhost:5173"
  : import.meta.env.VITE_FRONTEND_URL_PROD ||
    "https://dev-fe-v1.d3ei33981gtoeh.amplifyapp.com";

// Auth endpoints
export const AUTH_ENDPOINTS = {
  LOGIN: `${API_URL}/auth/login`,
  GOOGLE_LOGIN: `${API_URL}/auth/google/login`,
  OUTLOOK_LOGIN: `${API_URL}/auth/outlook/login`,
  GOOGLE_AUTHORIZE: `${API_URL}/auth/google/authorize`,
  OUTLOOK_AUTHORIZE: `${API_URL}/auth/outlook/authorize`,
  GOOGLE_START: `${API_URL}/auth/start/google`,
  OUTLOOK_START: `${API_URL}/auth/start/outlook`,
  GOOGLE_CONNECT: `${API_URL}/auth/connect/google/start`,
  OUTLOOK_CONNECT: `${API_URL}/auth/connect/outlook/start`,
  USER_ACCOUNTS: `${API_URL}/auth/connected-accounts`,
  REMOVE_ACCOUNT: `${API_URL}/auth/disconnect-account`,
  USER_INFO: `${API_URL}/auth/me`,
  LOGOUT: `${API_URL}/auth/logout`,
};

// API endpoints
export const API_ENDPOINTS = {
  USER_CONFIG: `${API_URL}/user/config`,
  GET_CONFIG: `${API_URL}/user/get-config`,
  UPDATE_CONFIG: `${API_URL}/user/update-config`,
  // "/user/config"
  // Update "/user/update-config"
  EMAILS: (userId, accountId) =>
    `${API_URL}/user/${userId}/accounts/${accountId}/emails`,
  CATEGORIES: (userId, accountId) =>
    `${API_URL}/user/${userId}/accounts/${accountId}/emails/categories`,
  ALL_CATEGORIES: (userId) => `${API_URL}/user/${userId}/emails/categories/all`,
  DRAFTS: (userId, accountId) =>
    `${API_URL}/user/${userId}/accounts/${accountId}/emails/drafts`,
  SEND_EMAIL: (userId, accountId, emailId) =>
    `${API_URL}/user/${userId}/accounts/${accountId}/emails/${emailId}/send`,
  DELETE_EMAIL: (userId, accountId, emailId) =>
    `${API_URL}/user/${userId}/accounts/${accountId}/emails/${emailId}`,
  SET_PRIMARY_ACCOUNT: (accountId) =>
    `${API_URL}/user/set-primary-account/${accountId}`,
  CALENDAR_TODAY: `${API_URL}/calendar/today`,
  CALENDAR_ACCOUNT: (userId) => `${API_URL}/calendar/${userId}/today`,
  CALENDAR_EVENTS: (userId, accountId, startDate, endDate) =>
    `${API_URL}/calendar/${userId}/accounts/${accountId}/events?start_date=${startDate}&end_date=${endDate}`,
  CALENDAR_ALL_EVENTS: (userId) =>
    `/calendar/${userId}/accounts/all/events?start_date=${startDate}&end_date=${endDate}`,
};
